import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'

/*
 * Gemeinsame Kartenebenen der taktischen Karte (Führung: bearbeitbar, Admin: nur lesend):
 * Hintergrundkarten und die DIPUL-Geozonen nach §21h LuftVO.
 */

export type Grundkarte = 'karte' | 'satellit' | 'topo'
/** Hintergrund-Wahl; „keine“ gibt es nur beim Drucken (weißer Hintergrund) */
export type GrundkarteWahl = Grundkarte | 'keine'

export const GRUNDKARTEN: Array<{ key: Grundkarte; label: string; url: string; attribution: string; maxNativeZoom: number }> = [
  {
    key: 'karte', label: 'Karte',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    maxNativeZoom: 19,
  },
  {
    key: 'satellit', label: 'Satellit',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Luftbild: &copy; Esri, Maxar, Earthstar Geographics',
    maxNativeZoom: 19,
  },
  {
    key: 'topo', label: 'Höhenlinien',
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: 'Kartendaten: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (CC-BY-SA)',
    maxNativeZoom: 17,
  },
]

/* DIPUL: WMS 1.1.1 (EPSG:3857), CORS offen. */
export const DIPUL_OWS = 'https://uas-betrieb.de/geoservices/dipul/ows'

export const GEOZONEN: Array<{ key: string; layer: string; label: string; farbe: string }> = [
  { key: 'flugbeschraenkung', layer: 'flugbeschraenkungsgebiete',           label: 'Flugbeschränkungsgebiete',          farbe: '#dc2626' },
  { key: 'temporaer',         layer: 'temporaere_betriebseinschraenkungen', label: 'Temporäre Einschränkungen (NOTAM)', farbe: '#f59e0b' },
  { key: 'kontrollzone',      layer: 'kontrollzonen',                       label: 'Kontrollzonen',                     farbe: '#2563eb' },
  { key: 'flughafen',         layer: 'flughaefen',                          label: 'Flughäfen',                         farbe: '#7c3aed' },
  { key: 'flugplatz',         layer: 'flugplaetze',                         label: 'Flugplätze',                        farbe: '#0891b2' },
  { key: 'militaer',          layer: 'militaerische_anlagen',               label: 'Militärische Anlagen',              farbe: '#4b5563' },
  { key: 'naturschutz',       layer: 'naturschutzgebiete',                  label: 'Naturschutzgebiete',                farbe: '#15803d' },
]

export const GEOZON_ATTRIBUTION = 'Geozonen: &copy; DFS/DIPUL – §21h LuftVO (kostenfrei)'

/**
 * DIPUL-Geozone als WMS-Overlay. Leaflets einfacher TileLayer kennt `{bbox-epsg-3857}` NICHT –
 * nur `L.tileLayer.wms` baut die bbox korrekt. Version 1.1.1: bbox in x,y-Reihenfolge.
 */
export function WmsGeozon({ layer, opacity = 0.75 }: { layer: string; opacity?: number }) {
  const map = useMap()
  useEffect(() => {
    const wms = L.tileLayer.wms(DIPUL_OWS, {
      layers: layer,
      styles: '',
      format: 'image/png',
      transparent: true,
      version: '1.1.1',
      opacity,
      attribution: GEOZON_ATTRIBUTION,
      crossOrigin: true,
    })
    wms.addTo(map)
    return () => { map.removeLayer(wms) }
  }, [map, layer, opacity])
  return null
}
